import { useCallback, useMemo } from 'react';

import useObjectTypeId from 'framework-listing-lib/internal/hooks/useObjectTypeId';
import { safeParseJSON } from 'framework-listing-lib/utils/json';
import {
  useReadLocalStore,
  useWriteLocalStore,
} from '../../hooks/useLocalStore';
import useApplicationId from '../../hooks/useApplicationId';

function getStorageKey({
  objectTypeId,
  applicationId,
}: {
  objectTypeId: string;
  applicationId: string;
}) {
  return `ListingLibFoldersColumns:${objectTypeId}:${applicationId}`;
}
export function useFetchPersistedFoldersColumns(enabled = true) {
  'use memo';

  const objectTypeId = useObjectTypeId();
  const applicationId = useApplicationId();
  const { data, loading } = useReadLocalStore(
    getStorageKey({ objectTypeId, applicationId }),
    { skip: !enabled }
  );

  const columns = useMemo(
    () => safeParseJSON<string[] | undefined>(data?.value ?? null, undefined),
    [data?.value]
  );

  return useMemo(() => {
    return {
      columns,
      loading,
    };
  }, [columns, loading]);
}

export function useSavePersistedFoldersColumns() {
  'use no memo';
  const objectTypeId = useObjectTypeId();
  const applicationId = useApplicationId();

  const [writeLocalStore] = useWriteLocalStore();

  return useCallback(
    (columns: string[]) => {
      return writeLocalStore({
        key: getStorageKey({ objectTypeId, applicationId }),
        value: JSON.stringify(columns),
      });
    },
    [writeLocalStore, objectTypeId, applicationId]
  );
}
